import { useState } from 'react';
import axios from 'axios';
import { exitToLogin } from '../../../component/AxiosCORS';

import * as Icons from '../../../images/icons/icons_component';

const UpdatePswd_modal = ({ updatePassInfo, setUpdatePassInfo, updatePassOpen, setUpdatePassOpen, handleInputChange, passInit, setOverYn, overYn }) => {

    const [prevPwOn, setPrevPwOn] = useState(false);
    const [newPwOn, setNewPwOn] = useState(false);
    const [reNewPwOn, setReNewPwOn] = useState(false);

    const getByteLength = (text) => {
        let byteLength = 0;
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i);
            if (charCode <= 0x007f) {
                byteLength += 1; // ASCII 문자
            } else if (charCode <= 0x07ff) {
                byteLength += 2; // 라틴, 일부 기호
            } else {
                byteLength += 2; // 대부분의 한글, 한자, 기타
            }
        }
        return byteLength;
    };

    const nextTime = () => {
        if (window.confirm('장기 미접속자일 경우, 비밀번호를 변경해 주시기 바랍니다.')) {
            setOverYn('N');
            setUpdatePassOpen(false);
        };
    }

    // 글자수(byte) 체크
    const getByte = getByteLength(updatePassInfo.newpswd);
    const newpswdByte = getByte < 257;

    // 문자 조합 정규식
    const passwordReg1 = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/;
    const passwordReg2 = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{10,}$/;
    const passwordReg3 = /^(?=.*?[a-zA-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;
    const passwordReg4 = /^(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/;

    // 문자 2조합, 최소 10자리 / 문자 3조합, 최소 9자리 체크
    const newpswdValid = passwordReg1.test(updatePassInfo.newpswd) || passwordReg2.test(updatePassInfo.newpswd) || passwordReg3.test(updatePassInfo.newpswd) || passwordReg4.test(updatePassInfo.newpswd);
    // 재입력 비밀번호 일치여부
    const sameNewpswd = updatePassInfo.newpswd === updatePassInfo.renewpswd;
    // 유효성 검사 완료 후 버튼 활성화
    const isValidCheckN = updatePassInfo.prevpswd.length < 1 || !newpswdByte || !newpswdValid || !sameNewpswd;

    const updatePassword = async (updatePassInfo) => {
        try {
            if (isValidCheckN) {
                alert('아래 주의사항을 확인하여 비밀번호를 입력해주세요.');
                return false;
            }
            if (window.confirm("비밀번호를 변경하시겠습니까?")) {
                const response = await axios.post('/commonapi/updatePassword.do', {
                    useridno: updatePassInfo.useridno,
                    userpswd: updatePassInfo.newpswd, // 변경할 암호
                    userpswd2: updatePassInfo.prevpswd, // 기존 암호
                });
                const result = response.data.resultMap.result;
                const resultMessage = response.data.resultMap.resultMessage;

                // 기존 비밀번호를 5회 틀려 계정이 잠겼다. 서버가 이미 로그아웃시켰으므로 로그인 화면으로 보낸다
                if (response.data.resultMap.locked) {
                    setUpdatePassOpen(false);
                    setUpdatePassInfo(passInit);
                    exitToLogin(resultMessage);
                    return;
                }

                alert(resultMessage);
                if (result) {
                    setUpdatePassOpen(false);
                    setUpdatePassInfo(passInit);
                }
            }
        } catch (error) {
            console.error('비밀번호 변경 중 오류 발생:', error);
        }
    };

    return (
        <div className={`mypage_modal_container ${updatePassOpen ? 'visible' : 'invisible'}`}>
            <div className='modal_title_box'>
                <Icons.PwDalgu />
                {overYn === 'Y' ?
                    <h4 className='co_red'>비밀번호 변경 <span className='co_black'>대상자 입니다.</span></h4>
                    :
                    <h4 className='co_red'>비밀번호<span className='co_black'>를 변경해 주세요.</span></h4>
                }
            </div>
            <p className='co_dark text-center'>영문, 숫자, 특수문자 중 2종류 이상 조합 최소 10자리<br />또는 3종류 이상 조합 최소 9자리</p>
            <hr />
            <div className='pw_box'>
                <div className='pw_input_box'>
                    <div className='flex justify-between'>
                        <label className='ml-1 cursor-default' htmlFor='prevpswd'>기존 비밀번호 입력</label>
                    </div>
                    <div className={`pw_input ${updatePassInfo.prevpswd.length > 0 ? 'pw_input_ok' : ''}`}>
                        <input className='outline_none' type={prevPwOn ? 'text' : 'password'} maxLength={20} name='prevpswd' value={updatePassInfo.prevpswd} onChange={handleInputChange} />
                        <div onClick={() => setPrevPwOn(!prevPwOn)}>
                            <button>{prevPwOn ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}</button>
                        </div>
                    </div>
                </div>
                <div className='pw_input_box'>
                    <div className='flex justify-between'>
                        <label className='ml-1 cursor-default' htmlFor='newpswd'>신규 비밀번호 입력</label>
                        <div className={`flex items-center ${updatePassOpen && updatePassInfo.newpswd.length > 0 && !newpswdValid ? 'visible' : 'invisible'}`}>
                            <Icons.NoticeIco16 />
                            <p className='co_red'>상단의 비밀번호 조건을 확인해 주세요.</p>
                        </div>
                    </div>
                    <div className={`pw_input ${updatePassInfo.newpswd.length > 0 && !newpswdValid ? 'pw_input_notice' : updatePassInfo.newpswd.length < 1 ? '' : 'pw_input_ok'}`}>
                        <input className='outline_none' type={newPwOn ? 'text' : 'password'} maxLength={20} name='newpswd' value={updatePassInfo.newpswd} onChange={handleInputChange} />
                        <div onClick={() => setNewPwOn(!newPwOn)}>
                            <button>{newPwOn ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}</button>
                        </div>
                    </div>
                </div>
                <div className='pw_input_box'>
                    <div className='flex justify-between'>
                        <label className='ml-1 cursor-default' htmlFor='renewpswd'>신규 비밀번호 재입력</label>
                        <div className={`flex items-center ${updatePassOpen && updatePassInfo.renewpswd.length > 0 && !sameNewpswd ? 'visible' : 'invisible'}`}>
                            <Icons.NoticeIco16 />
                            <p className='co_red'>신규 비밀번호와 일치하지 않습니다.</p>
                        </div>
                    </div>
                    <div className={`pw_input ${updatePassInfo.renewpswd.length > 0 && !sameNewpswd ? 'pw_input_notice' : updatePassInfo.renewpswd.length < 1 ? '' : 'pw_input_ok'}`}>
                        <input className='outline_none' type={reNewPwOn ? 'text' : 'password'} maxLength={20} name='renewpswd' value={updatePassInfo.renewpswd} onChange={handleInputChange} />
                        <div onClick={() => setReNewPwOn(!reNewPwOn)}>
                            <button>{reNewPwOn ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}</button>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className='modal_btn_box'>
                <button className={`modal_btn ${isValidCheckN ? 'bg_co_light' : 'bg_co_red'}`} disabled={isValidCheckN} onClick={() => updatePassword(updatePassInfo)}>변경하기</button>
                {overYn === 'Y' ?
                    <button className='modal_btn bg_co_black' onClick={() => nextTime()}>다음에 변경하기</button>
                    :
                    <button className='modal_btn bg_co_black' onClick={() => setUpdatePassOpen(false)}>닫기</button>
                }
            </div>
        </div>
    )
}

export default UpdatePswd_modal